import { render, staticRenderFns } from "./LEAGUERANKCHANGE.vue?vue&type=template&id=048e4b5e"
import script from "./LEAGUERANKCHANGE.vue?vue&type=script&lang=js"
export * from "./LEAGUERANKCHANGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports